import { colors } from '../../colors';
var fieldError = {
  errorColor: colors.warningRed
};
export default fieldError;